import { createRouter, createWebHistory } from "vue-router";
// import NProgress from 'nprogress'; // progress bar
// import 'nprogress/nprogress.css';

import DefaultLayout from "@/layout/default-layout.vue";
//import appRoutes from "./routes";
// import adminRouters from "./admin-routers";
import createRouteGuard from "./guard";
// import setupPermissionGuard from "./guard/permission";

const router = createRouter({
  history: createWebHistory("/web/"),
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/login/index.vue"),
      meta: {
        requiresAuth: false,
        locale: "军人体能训练管理考核系统",
      },
    },
    {
      path: "/auth",
      name: "auth",
      component: () => import("@/views/login/indexAuth.vue"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/app/leader",
      name: "leader",
      component: () => import("@/views/leader/index.vue"),
      meta: {
        locale: "首长座舱",
        requiresAuth: true,
        roles: ["*"],
      },
    },
    {
      path: "/app/prescription/personal",
      name: "prescriptionPersonal",
      component: () => import("@/views/prescription/personal/index.vue"),
      meta: {
        locale: "团队评估",
        requiresAuth: true,
        roles: ["*"],
      },
    },
    {
      path: "/app/prescription/team",
      name: "prescriptionTeam",
      component: () => import("@/views/prescription/team/index.vue"),
      meta: {
        locale: "团队评估",
        requiresAuth: true,
        roles: ["*"],
      },
    },
    {
      path: "/app/person",
      name: "person",
      component: () => import("@/views/person/index.vue"),
      meta: {
        locale: "个人训考数据",
        requiresAuth: true,
        roles: ["*"],
      },
    },
    {
      name: "home",
      path: "/home",
      meta: {
        locale: "首页",
        requiresAuth: true,
        roles: ["*"],
      },
      component: () => import("@/views/home.vue"),
    },
    {
      path: "/userCenter",
      name: "userCenter",
      component: DefaultLayout,
      redirect: "/userCenter/userSetting",
      meta: {
        locale: "用户",
        requiresAuth: true,
        hideInMenu: true,
      },
      children: [
        {
          path: "userSetting",
          name: "userSetting",
          component: () => import("@/views/user/setting.vue"),
          meta: {
            locale: "个人中心",
            requiresAuth: true,
            roles: ["*"],
            hideInMenu: true,
          },
        },
      ],
    },
    {
      path: "/steeplechase",
      name: "steeplechase",
      component: () => import("@/views/steeplechase/index.vue"),
      meta: {
        requiresAuth: false,
        locale: "400米障碍跑",
        keepAlive: true,
      },
    },
    {
      path: "/battleCb",
      name: "battleCb",
      component: () => import("@/views/battleCb/index.vue"),
      meta: {
        requiresAuth: false,
        locale: "战场机动组合",
        keepAlive: true,
      },
    },
    {
      path: "/bayonetCharge",
      name: "bayonetCharge",
      component: () => import("@/views/bayonetCharge/bayonetCharge.vue"),
      meta: {
        requiresAuth: false,
        locale: "人人刺杀",
        keepAlive: true,
      },
    },
    {
      path: "/bayonetCharge/result",
      name: "result",
      component: () => import("@/views/bayonetCharge/result.vue"),
      meta: {
        requiresAuth: false,
        locale: "运动分析",
        keepAlive: true,
      },
    },
    {
      path: "/bayonetCharge/history",
      name: "history",
      component: () => import("@/views/bayonetCharge/history.vue"),
      meta: {
        requiresAuth: false,
        locale: "数据查询",
        keepAlive: true,
      },
    },
    {
      path: "/h5",
      name: "h5",
      meta: {
        locale: "h5",
        requiresAuth: false,
        hideInMenu: true,
      },
      children: [
        {
          path: "dashboard-train",
          name: "dashboardTrain",
          component: () => import("@/views/h5/train.vue"),
          meta: {
            locale: "训练数据大屏",
            requiresAuth: false,
            roles: ["*"],
            hideInMenu: true,
          },
        },{
          path: "dashboard-exam",
          name: "dashboardExam",
          component: () => import("@/views/h5/exam.vue"),
          meta: {
            locale: "考核数据大屏",
            requiresAuth: false,
            roles: ["*"],
            hideInMenu: true,
          },
        },{
          path: "dashboard-holo",
          name: "dashboardHolo",
          component: () => import("@/views/h5/holo.vue"),
          meta: {
            locale: "个人训考数据",
            requiresAuth: false,
            roles: ["*"],
            hideInMenu: true,
          },
        },
        {
          path: "trainingBoard",
          name: "trainingBoard",
          component: () => import("@/views/h5/task/index.vue"),
          meta: {
            locale: "考核分析看板",
            requiresAuth: false,
            roles: ["*"],
            hideInMenu: true,
          },
        },
      ],
    }
  ],
  scrollBehavior() {
    return { top: 0 };
  },
});

createRouteGuard(router);
// setupPermissionGuard(router);
export default router;
